import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import request from 'lib/request';
import type { EvaluationOutputResponse } from './types';

export const evaluationOutputIdAtom = atom<number | null>(null);

const evaluationOutputBaseAtom = atom(async (get) => {
  const id = get(evaluationOutputIdAtom);
  if (!id) return null;

  const response = await request.get<EvaluationOutputResponse>(
    `/admin/development_area_evaluation_outputs/${id}`
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});

export const evaluationOutputAtom = loadable(evaluationOutputBaseAtom);
